import util from '../util'

let controller = 'ParceiroSocio'
export default Object.assign({}, util.GetCrud(controller, null))